import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireSharedService {
  onNewPhotosEvent: EventEmitter<any> = new EventEmitter();
  onNewCommentEvent: EventEmitter<any> = new EventEmitter();
  onAnswerChangeEvent: EventEmitter<any> = new EventEmitter();
}
